export var createTestAudioContextCloseMethodSupport = function createTestAudioContextCloseMethodSupport(nativeAudioContextConstructor) {
  return function () {
    if (nativeAudioContextConstructor === null) {
      return false;
    }
    // Try to check the prototype before constructing the AudioContext.
    if (nativeAudioContextConstructor.prototype !== undefined && nativeAudioContextConstructor.prototype.close !== undefined) {
      return true;
    }
    var audioContext = new nativeAudioContextConstructor();
    var isAudioContextClosable = audioContext.close !== undefined;
    try {
      audioContext.close();
    } catch (_unused) {
      // Ignore errors.
    }
    return isAudioContextClosable;
  };
};